// src/components/RequirePermission.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider"; // path to your AuthProvider hook

/**
 * RequirePermission
 * - permission: string like "rbac.manage" or "bookings.verify"
 * - children: protected content
 *
 * Behavior:
 * - if not authenticated -> redirect to login
 * - if authenticated but doesn't have permission -> redirect to /admin/forbidden
 * - otherwise render children
 */
const RequirePermission = ({ permission, children }) => {
  // AuthProvider should expose `me` and `permissionSet` or `permissionList`
  const { me, permissionSet, loading } = useAuth(); // adjust to your implementation

  // while auth data loading, render nothing (or a spinner)
  if (loading) return null;

  // not logged in -> login page
  if (!me) return <Navigate to="/admin/login" replace />;

  // superadmin bypass (if you use roles)
  if ((me.roles || []).includes("SUPER_ADMIN")) return <>{children}</>;

  // check permissionSet (a Set) first, else check permissionList (array)
  const hasPermission =
    permissionSet?.has(permission) ||
    (Array.isArray(me?.permissionList) && me.permissionList.includes(permission));

  if (!hasPermission) {
    return <Navigate to="/admin/forbidden" replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
